export default class Information {
  constructor(id, category, info) {
    this.id = id != null ? id : "";
    this.category = category != null ? category : "";
    this.info = info != null ? info : "";
  }
}
